import { Tooltip } from '@app/components/various/Tooltip';
import { getOrderPathByStatus } from '@app/logic/Orders';
import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { isEmpty } from '@app/utils/isEmpty';
import { Order } from '@typings';
import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  order: Order.Essentials;
}

export const OrderNumberNameColumn = ({ order }: Props) => {
  const { order: orderId, name, status, orderNumber } = order;
  const ref = React.useRef<HTMLDivElement>(null);
  const path = getOrderPathByStatus(orderId, status);
  const isOverflowing = useIsOverflowing(ref, { widthOnly: true });

  return (
    <Link to={path} className="table-row-interaction">
      <Tooltip content={isOverflowing && name}>
        <div ref={ref} className="relative z-interactiveTableItem max-w-52 truncate">
          <span className="body-1">{orderNumber}</span>
          {isEmpty(name) ? '' : ` - ${name}`}
        </div>
      </Tooltip>
    </Link>
  );
};
